import * as yup from 'yup';

const PriorityTypeSchema = yup.object({
  name: yup.string().required('Name is required'),
});

export { PriorityTypeSchema };
